module.exports = __webpack_public_path__ + "static/img/New-RGh-Sectors-header.0db0dde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/New-RGh-Sectors-header.jpg
// module id = 4Uhv
// module chunks = 1